import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

export default function BackButton({ set })
{

    const goBackButton = () =>
    {
        if (set.backUrl != null)
        {
            // go to custom URL against set
            window.location.href = set.backUrl;
        }
        else
        {
            window.history.back();
        }
    }

    return (
        <span onClick={goBackButton} className="primary-underline-link text-casing">
            <FontAwesomeIcon icon={icon({ name: 'arrow-left', style: 'solid' })} className="me-2" />
            Go Back
        </span>
    );
}